export default function quickEquals(newValue, oldValue) {
	if (newValue === oldValue) {
		return true;
	}

	// If its a primitive and doesnt match we should bail out before going further
	if (isPrimitiveOrNull(newValue) || isPrimitiveOrNull(oldValue)) return false;

	// Trying to rule out anything that might cause false positive for typeof === object later on
	if (!supportedType(newValue)) return false;
	if (!supportedType(oldValue)) return false;
	if (typeof newValue !== typeof oldValue) return false;

	if (isEmptyMatch(newValue, oldValue)) {
		return false;
	}

	if (Array.isArray(newValue)) {
		let {length: newValueLength} = newValue;
		let {length: oldValueLength} = oldValue;
		if (newValueLength !== oldValueLength) return false;
		if (newValueLength > 10) return false;
		if (newValueLength < 1) return false;

		for (let i = 0; i < newValueLength; i++) {
			if (!isPrimitiveOrNull(newValue[i]) || !isPrimitiveOrNull(oldValue[i])) {
				return false;
			} else if (newValue[i] !== oldValue[i]) {
				return false;
			}
		}

		return true;
	} else if (typeof newValue === 'object') {
		let keys = Object.keys(newValue);
		let {length: newKeyLength} = keys;
		let {length: oldKeyLength} = Object.keys(oldValue);

		if (newKeyLength !== oldKeyLength) return false;
		if (newKeyLength > 6) return false;
		for (let key in keys) {
			key = keys[key];
			if (isPrimitive(newValue[key]) && isPrimitive(oldValue[key])) {
				if (newValue[key] !== oldValue[key]) {
					return false;
				}

				continue;
			} else if (isUndefinedOrNull(newValue[key]) || isUndefinedOrNull(oldValue[key])) {
				return false;
			} else if (
				Object.keys(newValue[key]).length === 2 &&
				Object.keys(oldValue[key]).length === 2
			) {
				let currentKeys = Object.keys(newValue[key]);
				let current1 = newValue[key][currentKeys[0]];
				let current2 = newValue[key][currentKeys[1]];
				let old1 = oldValue[key][currentKeys[0]];
				let old2 = oldValue[key][currentKeys[1]];
				if (
					!isPrimitiveOrNull(current1) ||
					!isPrimitiveOrNull(current2) ||
					!isPrimitiveOrNull(old1) ||
					!isPrimitiveOrNull(old2)
				) {
					return false;
				} else if (current1 !== old1 || current2 !== old2) {
					return false;
				}
			} else {
				return false;
			}
		}

		return true;
	}

	return false;
}

function supportedType(value) {
	if (value instanceof Set) {
		return false;
	} else if (value instanceof Map) {
		return false;
	} else if (typeof value === 'function') {
		return false;
	} else if (Object.getOwnPropertySymbols(value).length > 0) {
		return false;
	} else if (value instanceof HTMLElement) {
		return false;
	}

	return true;
}

function isPrimitiveOrNull(value) {
	return isPrimitive(value) || isUndefinedOrNull(value);
}

function isPrimitive(value) {
	const type = typeof value;
	if (type === 'object' || type === 'function') return false;

	if (type === 'string') return true;
	if (type === 'bigint') return true;
	if (type === 'boolean') return true;
	if (type === 'number') return true;

	return false;
}

function isUndefinedOrNull(value) {
	return value === null || value === undefined;
}

function isEmptyMatch(newValue, oldValue) {
	if (newValue instanceof Map && oldValue instanceof Map) {
		return newValue.size === 0 && oldValue.size === 0;
	} else if (Array.isArray(newValue) && Array.isArray(oldValue)) {
		return newValue.length === 0 && oldValue.length === 0;
	}

	return Object.keys(newValue).length === 0 && Object.keys(oldValue).length === 0;
}
